// Định dạng dùng chung cho trang "Xu & Hạng": số, giờ VN, nhãn nguồn Xu, màu hạng.

export const fmtNum = (n) => (n === null || n === undefined || n === "" ? "—" : Number(n).toLocaleString("vi-VN"));

const pad = (n) => String(n).padStart(2, "0");

/** Unix giây → "dd/MM/yyyy HH:mm" theo giờ VN (UTC+7), không phụ thuộc múi giờ máy admin. */
export function fmtVnDateTime(sec) {
    if (!sec) return "—";
    const d = new Date((Number(sec) + 7 * 3600) * 1000);
    return `${pad(d.getUTCDate())}/${pad(d.getUTCMonth() + 1)}/${d.getUTCFullYear()} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}

/** 'YYYY-MM-DD' → 'dd/MM/yyyy'. */
export const fmtVnDate = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : "—");

export const SOURCE_LABELS = {
    checkin: "Điểm danh",
    checkin_milestone: "Mốc chuỗi",
    mission: "Nhiệm vụ",
    mission_bonus: "Thưởng đủ 3 nhiệm vụ",
    pending_release: "Nhả thưởng chờ",
    admin: "Admin chỉnh tay",
    adjust: "Admin chỉnh tay",
};
export const sourceLabel = (s) => SOURCE_LABELS[s] || s;

export const KIND_LABELS = { earn: "Cộng", revoke: "Thu hồi", expire: "Hết hạn", adjust: "Điều chỉnh", spend: "Tiêu" };

export const MISSION_LABELS = { deal_view: "Xem deal", buy_now: "Mua ngay (giờ vàng)", order_app: "Có đơn mua qua app" };
/** Tên NV: ưu tiên tên server trả (missionTitles), rồi nhãn 3 NV gốc, cuối cùng mới là mã thô. */
export const missionName = (key, titles = {}) => titles[key] || MISSION_LABELS[key] || key;
/** Các key NV hiện trong thống kê: theo missionTitles (nếu có) + mọi key xuất hiện trong dữ liệu ngày. */
export const missionKeys = (days, titles = {}) => {
    const set = new Set(Object.keys(titles).length ? Object.keys(titles) : Object.keys(MISSION_LABELS));
    days.forEach((d) => Object.keys(d.missions || {}).forEach((k) => set.add(k)));
    return [...set];
};
export const MISSION_STATUS_LABELS = { claimed: "Đã nhận", completed: "Chờ nhận", in_progress: "Đang làm", locked: "Chưa làm", revoked: "Đã thu hồi" };

const TIER_COLORS = ["default", "green", "blue", "purple", "gold"];
const tierIndex = (tier) => Math.min(Math.max(Number(tier) || 1, 1), 5) - 1;
export const tierColor = (tier) => TIER_COLORS[tierIndex(tier)];
/** Màu hex từng hạng — dùng cho thanh/biểu đồ (Tag của antd chỉ nhận tên màu). */
const TIER_HEX = ["#94A3B8", "#16A34A", "#2563EB", "#7C3AED", "#D97706"];
export const tierHex = (tier) => TIER_HEX[tierIndex(tier)];

/** Phần trăm 1 chữ số kiểu Việt ("42,9%"); null → "—". */
export const fmtPct = (p) => (p === null || p === undefined ? "—" : `${Number(p).toLocaleString("vi-VN", { maximumFractionDigits: 1 })}%`);

/** Xu → đồng (2 Xu = 1đ), làm tròn xuống, có đơn vị. */
export const fmtVndFromXu = (xu) => `${fmtNum(Math.floor((Number(xu) || 0) / 2))}đ`;

export const PLATFORM_LABELS = { ios: "iOS", android: "Android" };
export const platformLabel = (p) => PLATFORM_LABELS[String(p || "").toLowerCase()] || null;
export const ROLE_LABELS = { admin: "admin", mod: "CTV" };

/** Lỗi API → câu tiếng Việt cho message.error. */
export const apiError = (e, fallback) => e?.response?.data?.message || fallback;
